import { useContext, createContext } from 'react';

// ----------------------------------------------------------------------

export type NavigationDialogContextProps = {
  isOpen: boolean;
  title?: string;
  content?: string;
  pendingNavigation: (() => void) | null;
  showConfirmDialog: (title?: string, content?: string) => Promise<boolean>;
  closeDialog: () => void;
  confirmNavigation: () => void;
  cancelNavigation: () => void;
};

export const NavigationDialogContext = createContext({} as NavigationDialogContextProps);

export const useNavigationDialog = () => {
  const context = useContext(NavigationDialogContext);

  if (!context) {
    throw new Error('useNavigationDialog must be used inside NavigationDialogProvider');
  }

  return context;
};